module.exports = {
  "/": {},
  "/:knowledgeBaseId": {},
  "/:knowledgeBaseId/articles": {},
  "/:knowledgeBaseId/articles/state": {},
  "/articles/state/:state": {},
  "/:knowledgeBaseId/articles/state/:state": {
    "name": "articleManagement",
    "success": {
      "v2 article table loaded": [
        "V2_HEADER_RENDERED",
        "V2_ARTICLES_LOADED"
      ],
      "v3 article table loaded": [
        "V3_HEADER_RENDERED",
        "V3_ARTICLES_LOADED"
      ]
    },
    "error": [
      "MANAGE_ERROR"
    ]
  },
  "/:knowledgeBaseId/organize": {
    "name": "categoryManagement",
    "success": {
      "category management loaded": [
        "ORGANIZE_LOAD"
      ]
    }
  },
  "/insights/dashboard": {},
  "/:knowledgeBaseId/insights/dashboard": {
    "success": {
      "onboarding": [
        "ONBOARDING_LOAD"
      ],
      "v2 analytics dashboard loaded": [
        "V2_HEADER_RENDERED",
        "DASHBOARD_LOAD",
        "ARTICLE_DETAILS_TABLE_LOAD"
      ],
      "v3 analytics dashboard loaded": [
        "V3_HEADER_RENDERED",
        "DASHBOARD_LOAD",
        "ARTICLE_DETAILS_TABLE_LOAD"
      ]
    },
    "error": [
      "DASHBOARD_ERROR"
    ]
  },
  "/:knowledgeBaseId/customize-template": {},
  "/:knowledgeBaseId/customize-template/:tabName": {
    "name": "legacyThemeEditor",
    "success": {
      "template editor sidebar loaded": [
        "TEMPLATE_EDITOR_SIDEBAR_LOAD"
      ],
      "template editor preview loaded": [
        "TEMPLATE_EDITOR_PREVIEW_LOAD"
      ]
    }
  },
  "/:knowledgeBaseId/customize-template/content/:item": {
    "name": "legacyThemeEditorSection",
    "success": {
      "template editor sidebar loaded": [
        "TEMPLATE_EDITOR_SIDEBAR_LOAD"
      ],
      "template editor preview loaded": [
        "TEMPLATE_EDITOR_PREVIEW_LOAD"
      ]
    }
  },
  "/edit/:articleId": {
    "name": "legacyArticleEditor",
    "success": {
      "v2 article editor loaded": [
        "ARTICLE_EDITOR_LOAD"
      ]
    }
  },
  "/insights/article/:articleId": {},
  "/insights/article/:articleId/performance": {
    "success": {
      "article performance": [
        "ARTICLE_PERFORMANCE_LOAD",
        "ARTICLE_VIEWS_OVER_TIME_REPORT_LOAD",
        "ARTICLE_VIEWS_REPORT_LOAD",
        "TIME_PER_ARTICLE_REPORT_LOAD"
      ],
      "not found": [
        "ARTICLE_DETAILS_NOT_FOUND"
      ]
    }
  },
  "/insights/article/:articleId/published": {
    "success": {
      "article published": [
        "ARTICLE_PUBLISHED_LOAD"
      ]
    }
  },
  "/:knowledgeBaseId/agent": {
    "name": "agent",
    "success": {
      "agent": [
        "V3_HEADER_RENDERED",
        "SUGGESTIONS_LOAD"
      ]
    }
  }
};